import { Star } from 'lucide-react';

type StarRatingProps = {
  value: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showValue?: boolean;
};

export function StarRating({
  value,
  className = '',
  size = 'md',
  showValue = true,
}: StarRatingProps) {
  const safeValue = Math.max(0, Math.min(5, Number(value) || 0));
  const stars = Array.from({ length: 5 }, (_, i) => i + 1);
  const iconSize =
    size === 'sm' ? 'h-3.5 w-3.5' : size === 'lg' ? 'h-5 w-5' : 'h-4 w-4';

  return (
    <div
      className={`inline-flex items-center gap-1 ${className}`}
      aria-label={`${safeValue.toFixed(1)} out of 5 stars`}
    >
      {stars.map((star) => {
        // Fraction of THIS star that should be filled (0 to 1).
        const fillPercent =
          Math.max(0, Math.min(1, safeValue - (star - 1))) * 100;

        return (
          <span key={star} className="relative inline-block leading-none">
            {/* base (empty) star */}
            <Star className={`${iconSize} text-gray-300 fill-transparent`} />
            {/* filled star, clipped to fillPercent width */}
            <span
              className="absolute top-0 left-0 overflow-hidden"
              style={{ width: `${fillPercent}%` }}
            >
              <Star className={`${iconSize} text-primary fill-primary`} />
            </span>
          </span>
        );
      })}
      {showValue && (
        <span className="ml-1 text-xs text-brandslate">
          ({safeValue.toFixed(1)})
        </span>
      )}
    </div>
  );
}

export default StarRating;
